// Vocabulário oficial definido pelo CES / Comitê de Equidade (US-99873).
// O value é a chave persistida pelo backend (nome do membro do enum);
// NAO_INFORMADO é estado interno e não é opção exibida ao cidadão.
// A ordem aqui é a ordem do select: "Prefiro não informar" vem primeiro
// (US-102684), já que o campo passou a ser obrigatório.
export const OrientacaoSexualOptions = [
  {
    value: "PREFIRO_NAO_INFORMAR",
    label: "Prefiro não informar",
    definicao: "Recusa consciente — resposta válida.",
  },
  {
    value: "HETEROSSEXUAL",
    label: "Heterossexual",
    definicao:
      "Atração afetiva/sexual somente por pessoas de gênero diferente daquele com o qual se identifica.",
  },
  {
    value: "LESBICA",
    label: "Lésbica",
    definicao:
      "Mulher que sente atração afetiva/sexual somente pelo mesmo gênero (outras mulheres).",
  },
  {
    value: "GAY",
    label: "Gay",
    definicao:
      "Homem que sente atração afetiva/sexual somente pelo mesmo gênero (outros homens).",
  },
  {
    value: "BISSEXUAL",
    label: "Bissexual",
    definicao:
      "Atração por mais de um gênero; o gênero não é fator determinante da atração.",
  },
  {
    value: "PANSEXUAL",
    label: "Pansexual",
    definicao: "Atração independente do gênero ou por todos os gêneros.",
  },
  {
    value: "ASSEXUAL",
    label: "Assexual",
    definicao: "Rara, condicionalmente ou nunca sente atração sexual.",
  },
  {
    value: "OUTRO",
    label: "Outro",
    definicao: "Não se identifica com as definições acima (campo aberto).",
  },
];

export const orientacaoSexualLabel = (value, textoOutro) => {
  if (!value || value === "NAO_INFORMADO") return "Não informado";
  if (value === "OUTRO" && textoOutro) return `Outro: ${textoOutro}`;
  const opcao = OrientacaoSexualOptions.find((o) => o.value === value);
  return opcao ? opcao.label : "Não informado";
};

export default OrientacaoSexualOptions;
